/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */

export default class ApiClient {
  static UPDATE_DATA = 'update-data'

  constructor (eventBus, url) {
    this.eventBus = eventBus
    this.url = url
  }

  listen () {
    this.eventBus.on(this.constructor.name, ApiClient.UPDATE_DATA, (data, cb) => this.updateData(data, cb))
  }

  async updateData (data, cb) {
    const updateUrl = this.url + '/onboarding/update'
    // console.log(updateUrl, data)
    const rawResponse = await fetch(updateUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })

    if (rawResponse.ok) {
      if (cb) cb()
    }
  }
}
